import { createAuthClient } from 'better-auth/react';
import config from '../config';
export var authClient = createAuthClient({
    baseURL: config.authUrl,
});
